// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"delivery-details_wrapper__5VVbP","item":"delivery-details_item__5saWN"};